import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getLastResults, getDetailResults } from "../../../../apiservices/CasionApi";
import RefResultModal from "../../../casinoComponents/refResultModal";
import Patti2ResultBody from "../../../casinoComponents/refResultModal/Patti2ResultBody";
import { formatRefMatchTime } from "../../../../utils/refMatchTime";

/**
 * 2 Cards Teenpatti "Last Result" items in the reference markup (inside .casino-video-last-results):
 *   win 1 → span.resulta "A", win 2 → span.resultb "B", win 0 → "T" (no class).
 * Click → .loader-overlay (in .page-content) while the round detail loads, then the reference
 * result modal ("{ename} Result"). Last results are refetched when the round changes (reference
 * calls getLastResults on a new mid). `onTitle` reports res1.cname (the reference's game title).
 */
const ResultPatti2 = ({ roundId, onTitle }) => {
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults("patti2");
        const res = response?.data?.data?.res;
        if (cancelled) return;
        if (Array.isArray(res)) setLastResults(res);
        const cname = response?.data?.data?.res1?.cname;
        if (cname && onTitle) onTitle(cname);
      } catch (error) {
        console.error("Error fetching last results:", error);
      }
    };
    fetchLastResults();
    return () => {
      cancelled = true;
    };
  }, [roundId, onTitle]);

  const handleResultClick = async (mid) => {
    if (loading || !mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults("patti2", String(mid));
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      setDetailResult(t1 || null);
      setShowModal(!!t1);
    } catch (error) {
      console.error("Error fetching detail results:", error);
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {lastResults.map((r, index) => {
        const win = String(r?.win ?? "");
        return (
          <span
            key={r?.mid ?? index}
            className={win === "1" ? "resulta" : win === "2" ? "resultb" : undefined}
            onClick={() => handleResultClick(r?.mid)}
          >
            {win === "1" && "A"}{" "}{win === "2" && "B"}{" "}{win === "0" && "T"}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector(".page-content") || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${detailResult?.ename || "2 Cards Teenpatti"} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        {detailResult && <Patti2ResultBody t1={detailResult} />}
      </RefResultModal>
    </>
  );
};

export default ResultPatti2;
